import { propOr } from 'ramda';
import { createTripEvent, createTimetableTripEvent } from '../../assets/javascripts/new/app/helpers/data-layer-helper';
(() => {
  // dataLayerHref Events
  const locale = I18n.locale;
  const dataLayerATagOnClick = aData => () => {
    const {
      price = null,
      from,
      to
    } = aData;
    const tripName = `${from} – ${to}`;
    createTripEvent(tripName, price);
  };
  const convertDatasetToJsObject = dataset => Object.keys(dataset).reduce((acc, key) => ({
    ...acc,
    [key]: JSON.parse(dataset[key])
  }), {});
  const getDataFromDatasetObject = dataset => {
    const mutableDataset = {};
    mutableDataset.price = !!dataset.price && dataset.price.hasOwnProperty('fractional') && String(dataset.price['fractional'] / 100);
    mutableDataset.from = dataset.from.names[locale];
    mutableDataset.to = dataset.to.names[locale];
    return mutableDataset;
  };
  const dataLayerAMain = document.querySelectorAll('.data-layer__a-main');
  const dataLayerATimetable = document.querySelectorAll('.data-layer__a-timetable');
  [...dataLayerAMain].map(aTag => aTag.addEventListener('click', dataLayerATagOnClick(getDataFromDatasetObject(convertDatasetToJsObject(aTag.dataset)))));
  [...dataLayerATimetable].map(aTag => aTag.addEventListener('click', dataLayerATagOnClick(aTag.dataset)));
  // Timetable Events
  const internalTrips = propOr([], 'internalTrips', global.gon);
  const internationalTrips = propOr([], 'internationalTrips', global.gon);
  const internalRadioBtn = document.querySelector("#radio_internal");
  if (internalRadioBtn) {
    internalRadioBtn.addEventListener('click', () => createTimetableTripEvent({
      trips: internalTrips
    }));
  }
  const internationalRadioBtn = document.querySelector('#radio_international');
  if (internationalRadioBtn) {
    internationalRadioBtn.addEventListener('click', () => createTimetableTripEvent({
      trips: internationalTrips
    }));
  }
})();